module.exports = __webpack_public_path__ + "static/media/machine learning.87b3b8e1.jpg";